var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kundenlogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "115.4px",
    height: "40.2px",
    viewBox: "0 0 115.4 40.2",
    style: {
      enableBackground: "new 0 0 115.4 40.2"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#Pfad_11467_00000137110074105691008140000017254565836009095565_);}\n\t.st2{fill:url(#Pfad_11468_00000117639288824055271740000004309949620133613995_);}\n\t.st3{fill:url(#Pfad_11469_00000061473553208908773170000017828997509053721485_);}\n\t.st4{fill:url(#Pfad_11470_00000016066273937890714120000017522794858002102155_);}\n\t.st5{fill:url(#Pfad_11471_00000005975524947315854750000009156315242913920654_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1057",
    x: 1.1,
    y: 0.2,
    className: "st0",
    width: 113.2,
    height: 39.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEW_Logo_RGB",
    transform: "translate(9 -3.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2236",
    transform: "translate(-9 4)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pfad_11467_00000018956969032804403500000004786947375516190142_",
    gradientUnits: "userSpaceOnUse",
    x1: -360.13,
    y1: 313.3791,
    x2: -359.5639,
    y2: 313.3791,
    gradientTransform: "matrix(193.4106 0 0 -59.6716 69655.9531 18719.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004BA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#008CC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#28A6DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    style: {
      stopColor: "#49BBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55C3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11467",
    style: {
      fill: "url(#Pfad_11467_00000018956969032804403500000004786947375516190142_)"
    },
    d: "M96.5,3.2 c-0.9,0-1.7,0.6-2,1.6l-3.6,14.7c0,0-0.4,1.6-0.8,0L86.9,9.1c-3.9,3.1-8.1,6.1-12.2,8.9l-0.4,1.5c0,0-0.5,1.5-0.8,0l-0.1-0.5 c0,0-4.8,2.9-7.1,4.2l2.2,7.8c4.1-1.2,7.9-2.4,11.5-3.6l1.8-5.5c0,0,0.5-1.5,1,0l1.3,4c5.9-2.2,11-4.4,15.2-6.4l4-14.8 c0,0,0.4-1.5-1.2-1.5L96.5,3.2L96.5,3.2z M3,21.9v13.4c0,0.9,0.7,1.6,1.5,1.6c0,0,0,0,0.1,0h5.1c0.9,0,1.6-0.6,1.6-1.5 c0,0,0-0.1,0-0.1v-9.7L3,21.9z M15.7,26.9l5.5,8.7c0.6,0.8,1.5,1.3,2.5,1.3h4.1c0.9,0,1.6-0.6,1.6-1.5c0,0,0-0.1,0-0.1v-6.2 L15.7,26.9z M34.3,29.1v6.2c0,0.9,0.6,1.6,1.5,1.6c0,0,0.1,0,0.1,0h4.6c5.9-0.9,11.5-2,16.8-3.2v-2.6c0-0.9-0.7-1.6-1.5-1.6 c0,0,0,0-0.1,0H44.2c-0.5,0-0.9-0.2-1.3-0.5C39.9,29.1,37,29.2,34.3,29.1 M108.4,3.2c-1,0-1.9,0.8-1.9,1.8c0,0,0,0.1,0,0.1v5.8 c0,0.4,0.3,2.3,1.8,1c0,0,2.2-1.9,2.5-2.1c1-0.8,1.6-2,1.6-3.3V5.3c0-0.3,0-2.1-1.9-2.1L108.4,3.2L108.4,3.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pfad_11468_00000094587923033213491900000004422395665642261666_",
    gradientUnits: "userSpaceOnUse",
    x1: -358.9749,
    y1: 309.5652,
    x2: -358.4088,
    y2: 309.5652,
    gradientTransform: "matrix(119.56 0 0 -32.6495 42922.0078 10119.5566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004BA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    style: {
      stopColor: "#007ABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#008CC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#26A4DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#48BBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55C3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11468",
    style: {
      fill: "url(#Pfad_11468_00000094587923033213491900000004422395665642261666_)"
    },
    d: "M21,14.3v4.2 c0,0,0,1.6-0.9,0.2l-2.6-4c-4.9,0.6-9.8,0.8-14.6,0.7v3.4c8.7,1.9,17.5,2.8,26.4,2.7v-9.3C26.7,12.9,23.9,13.9,21,14.3 M53.6,3.2 C47.5,6.6,41,9.4,34.3,11.4v10.1c7.1-0.4,14.1-1.8,20.7-4.2c-0.2-0.6-0.8-1.1-1.5-1h-9.3c-0.9,0-1.6-0.7-1.6-1.5c0,0,0,0,0-0.1 v-2.4c0-0.8,0.6-1.6,1.5-1.6c0,0,0.1,0,0.1,0h11.5c0.9,0,1.6-0.7,1.6-1.5c0,0,0,0,0-0.1V4.8c0-0.9-0.7-1.6-1.5-1.6c0,0,0,0-0.1,0 L53.6,3.2L53.6,3.2z M62.2,3.2c0,0-1.6,0-1.2,1.5l2.3,8.5c0.5-0.3,1-0.6,1.4-0.9c2-1.3,3.9-2.6,5.8-3.8l-0.9-3.8 c-0.2-0.9-1-1.5-2-1.6C67.7,3.2,62.2,3.2,62.2,3.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pfad_11469_00000111176928586610553470000009234237823501281459_",
    gradientUnits: "userSpaceOnUse",
    x1: -357.9639,
    y1: 305.3733,
    x2: -357.3978,
    y2: 305.3733,
    gradientTransform: "matrix(89.6106 0 0 -21.7998 32080.3457 6666.4092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E60028"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    style: {
      stopColor: "#C50645"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#A60B61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    style: {
      stopColor: "#930E72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#8C0F78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    style: {
      stopColor: "#881078"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    style: {
      stopColor: "#7B1278"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#661578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    style: {
      stopColor: "#491978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#281E78"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11469",
    style: {
      fill: "url(#Pfad_11469_00000111176928586610553470000009234237823501281459_)"
    },
    d: "M4.6,3.2 C3.7,3.1,3,3.8,3,4.7c0,0,0,0,0,0.1v10.7c4.9,0.1,9.8-0.2,14.6-0.7L11.1,4.5c-0.6-0.8-1.5-1.3-2.5-1.3H4.6z M22.6,3.2 c-0.9,0-1.6,0.7-1.6,1.5c0,0,0,0,0,0.1v9.6c2.9-0.4,5.6-1,8.3-1.6V4.8c0-0.9-0.7-1.6-1.5-1.6c0,0,0,0-0.1,0L22.6,3.2L22.6,3.2z  M35.9,3.2c-0.9,0-1.6,0.7-1.6,1.5c0,0,0,0,0,0.1v6.6c6.8-2,13.3-4.8,19.4-8.2H35.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pfad_11470_00000096777062460926481870000002997431892916062876_",
    gradientUnits: "userSpaceOnUse",
    x1: -359.567,
    y1: 312.047,
    x2: -359.001,
    y2: 312.047,
    gradientTransform: "matrix(148.66 0 0 -46.29 53456.2148 14460.9141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55C3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#49BBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#28A6DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#008CC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004BA0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11470",
    style: {
      fill: "url(#Pfad_11470_00000096777062460926481870000002997431892916062876_)"
    },
    d: "M3,21.9 c2.6,1.6,5.4,2.9,8.3,3.8v-4.2c0,0,0-1.6,0.9-0.2l3.6,5.7c4.5,1.1,9,1.8,13.6,2.1V21c-8.9-0.1-17.7-1.2-26.4-3.4h0V21.9z  M34.3,20.9v8.4c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0h1c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.2,0,0.4,0,0.5,0s0.4,0,0.5,0 s0.4,0,0.5,0c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0 c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0h0c0,0,0,0,0,0 c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.3,0-0.4v-2.7c0-0.9,0.7-1.6,1.5-1.6 c0,0,0,0,0.1,0h9.3c0.9,0,1.6-0.7,1.6-1.5c0,0,0,0,0-0.1v-4.2c0-0.2-0.1-0.4-0.1-0.7C48.3,19.5,41.3,20.7,34.3,20.9 M64.9,12.3 c-0.5,0.3-1,0.6-1.4,0.9l2.8,10.1c2.4-1.2,4.8-2.5,7.2-3.8c0,0,0,0,0,0L70.7,8.5C70.6,8.5,66.9,11,64.9,12.3 M80.8,3.2 c-0.9,0-1.8,0.6-2.1,1.5l-4.3,14.2c4.4-2.7,8.7-5.7,12.7-9l-1.6-5.2c-0.3-0.9-1.1-1.5-2.1-1.5C83.5,3.2,80.8,3.2,80.8,3.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pfad_11471_00000060029608402923948670000011337343156843576986_",
    gradientUnits: "userSpaceOnUse",
    x1: -358.992,
    y1: 310.2359,
    x2: -358.426,
    y2: 310.2359,
    gradientTransform: "matrix(111.72 0 0 -34.0406 40143 10587.9219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#281E78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#291E78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    style: {
      stopColor: "#531778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    style: {
      stopColor: "#721378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    style: {
      stopColor: "#851078"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#8C0F78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    style: {
      stopColor: "#930E72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    style: {
      stopColor: "#A60B61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    style: {
      stopColor: "#C50645"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E60028"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11471",
    style: {
      fill: "url(#Pfad_11471_00000060029608402923948670000011337343156843576986_)"
    },
    d: "M36.4,36.9h19.2 c0.9,0,1.6-0.7,1.6-1.5c0,0,0,0,0-0.1v-2.6 M68,29.9l1.5,5.5c0.3,0.9,1.1,1.5,2,1.5h3.5c0.9,0,1.8-0.6,2.1-1.5l3.1-9.4 C80.3,26,72.3,28.7,68,29.9 M83.6,24.8l3.5,10.7c0.3,0.9,1.1,1.5,2.1,1.5h3.6c0.9,0,1.8-0.6,2-1.5l4.9-17.7 C99.6,17.7,89.3,22.6,83.6,24.8"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.340f6a1c38afeb40f5c3bf38e8ec97da.svg";